import RHService from '../../../services/rh/rhService';
const api = new RHService()
const state = {
  questionarios: [],
  questionarios_loading: false,
  competencias: [],
  competencias_loading: false,
  periodos: [],
  periodos_loading: false,
  periodoquests: [],
  periodoquests_loading: false,
  colaboradores: [],
  colaboradores_loading: false,
  mentorias: [],
  mentorias_loading: false,
  gestor_colaboradores: [],
  gestor_colaboradores_loading: false,
  avaliar_loading: false,
  loaders: [],
  avaliacoesTempoCasa: []
};
const getters = {
  // StateQuestionarios: state => state.questionarios,
  StateAvaliacoesTempoCasa: state => state.avaliacoesTempoCasa,
  StateRHLoading: state => state.loaders,
  // StateQuestionariosLoading: state => state.questionarios_loading,
};
const mutations = {
  SetRHMentorias(state, value){state.mentorias = value },
  SetRHMentoriasLoading(state, value){state.mentorias_loading = value },
  SetRHQuestionarios(state, value){state.questionarios = value },
  SetRHQuestionariosLoading(state, value){state.questionarios_loading = value },
  SetRHCompetencias(state, value){state.competencias = value },
  SetRHCompetenciasLoading(state, value){state.competencias_loading = value },
  SetRHPeriodos(state, value) { state.periodos = value },
  SetRHPeriodosLoading(state, value) { state.periodos_loading = value },
  SetRHPeriodoQuests(state, value) { state.periodoquests = value },
  SetRHPeriodoQuestsLoading(state, value) { state.periodoquests_loading = value },
  SetRHColaboradores(state, value) { state.colaboradores = value },
  SetRHColaboradoresLoading(state, value) { state.colaboradores_loading = value },
  SetRHColaboradoresGestor(state, value) { state.gestor_colaboradores = value },
  SetRHColaboradoresGestorLoading(state, value) { state.gestor_colaboradores_loading = value },
  SetRHAvaliarLoading(state, value) { state.avaliar_loading = value },
  setRHLoading(state, value){ state.loaders.push(value) },
  dropRHLoading(state, value){ state.loaders.pop(value) },
  SetAvaliacoesTempoCasa(state, value){state.avaliacoesTempoCasa = value},
}
const actions = {
  // Mentorias
  async GetRHMentorias({ commit }, params) {
    commit('SetRHMentoriasLoading', true)
    commit('SetRHMentorias', [])
    try {
      const response = await api.get('respostas/mentorias/', params)
      commit('SetRHMentorias', response.data)
    } catch (error) {
      commit('SetRHMentorias', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHMentoriasLoading', false)
  },
  //  Competencias
  async GetRHCompetencias({ commit }, params) {
    commit('SetRHCompetenciasLoading', true)
    try {
      const response = await api.get('competencias/', {...params, page_size: 200})
      commit('SetRHCompetencias', response.data.results)
    } catch(error) {
      commit('SetRHCompetencias', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHCompetenciasLoading', false)
  },
  async CreateRHCompetencia({ commit, dispatch }, data) {
    commit('SetRHCompetenciasLoading', true)
    var created = false
    try {
      await api.post('competencias/', data)
      created = true
      dispatch('GetRHCompetencias')
      commit("setAlerts", [{
        tag:'success',
        title:'Cadastro de Competência',
        message:`Competência ${data.nome} criada com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHCompetenciasLoading', false)
    return created
  },
  async UpdateRHCompetencia({commit, dispatch }, data) {
    commit('SetRHCompetenciasLoading', true)
    var updated = false
    try {
      await api.patch(`competencias/${data.id}/`, data)
      updated = true
      dispatch('GetRHCompetencias')
      commit("setAlerts", [{
          tag:'success',
          title:'Alteração de Competência',
          message:`Competência ${data.nome} alterada com sucesso!`
        }])
    } catch (error) {
      updated = false
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHCompetenciasLoading', false)
    return updated
  },
  async DeleteRHCompetencia({commit, dispatch }, data) {
    commit('SetRHCompetenciasLoading', true)
    var deleted = false
    try {
      await api.delete(`competencias/${data.id}/`)
      deleted = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Exclusão de Competência',
        message:`Competência ${data.nome} removida com sucesso!`
        }])
      dispatch('GetRHCompetencias')
    } catch (error) {
      deleted = false
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHCompetenciasLoading', false)
    return deleted
  },
  //  Períodos
  async GetRHPeriodos({ commit }, params) {
    commit('SetRHPeriodosLoading', true)
    try {
      const response = await api.get('periodos/', {...params, page_size: 200})
      commit('SetRHPeriodos', response.data.results)
    } catch (error) {
      commit('SetRHPeriodos', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodosLoading', false)
  },
  async CreateRHPeriodo({ commit, dispatch }, data) {
    commit('SetRHPeriodosLoading', true)
    var created = false
    try {
      await api.post('periodos/', data)
      created = true
      dispatch('GetRHPeriodos')
      commit("setAlerts", [{
        tag:'success',
        title:'Cadastro de Período',
        message:`Período ${data.descricao} criado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodosLoading', false)
    return created
  },
  async UpdateRHPeriodo({ commit, dispatch }, data) {
    commit('SetRHPeriodosLoading', true)
    var updated = false
    try {
      await api.patch(`periodos/${data.id}/`, data)
      updated = true
      dispatch('GetRHPeriodos')
      commit("setAlerts", [{
        tag:'success',
        title:'Alteração de Período',
        message:`Período ${data.descricao} alterado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodosLoading', false)
    return updated
  },
  async DeleteRHPeriodo({ commit, dispatch }, data) {
    commit('SetRHPeriodosLoading', true)
    var deleted = false
    try {
      await api.delete(`periodos/${data.id}/`)
      deleted = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Exclusão de Período',
        message:`Período ${data.nome} removido com sucesso!`
        }])
      dispatch('GetRHPeriodos')
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodosLoading', false)
    return deleted
  },
  // Questionário
  async GetRHQuestionarios({ commit }, params) {
    commit('SetRHQuestionariosLoading', true)
    commit('SetRHQuestionarios', [])
    try {
      const response = await api.get('questionarios/', {...params, page_size: 500})
      commit('SetRHQuestionarios', response.data.results)
    } catch (error) {
      commit('SetRHQuestionarios', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHQuestionariosLoading', false)
  },
  async CreateRHQuestionario({ commit, dispatch }, data) {
    commit('SetRHQuestionariosLoading', true)
    var created = false
    try {
      await api.post('questionarios/', data)
      created = true
      dispatch('GetRHQuestionarios')
      commit("setAlerts", [{
        tag:'success',
        title:'Cadastro de Questionário',
        message:`Questionário criado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHQuestionariosLoading', false)
    return created
  },
  async UpdateRHQuestionario({ commit, dispatch }, data) {
    commit('SetRHQuestionariosLoading', true)
    var updated = false
    try {
      await api.patch(`questionarios/${data.id}/`, data)
      updated = true
      dispatch('GetRHQuestionarios')
      commit("setAlerts", [{
        tag:'success',
        title:'Alteração de Questionário',
        message:`Questionário alterado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHQuestionariosLoading', false)
    return updated
  },
  async DeleteRHQuestionario({ commit, dispatch }, data) {
    commit('SetRHQuestionariosLoading', true)
    var deleted = false
    try {
      await api.delete(`questionarios/${data.id}/`)
      deleted = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Exclusão de Questionário',
        message:`Questionário removido com sucesso!`
        }])
      dispatch('GetRHQuestionarios')
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHQuestionariosLoading', false)
    return deleted
  },
  //  Periodo Questionario
  async GetRHPeriodoQuests({ commit }, params) {
    commit('SetRHPeriodoQuestsLoading', true)
    try {
      const response = await api.get('periodo-questionarios/', {...params, page_size: 200})
      commit('SetRHPeriodoQuests', response.data.results)
    } catch (error) {
      commit('SetRHPeriodoQuests', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodoQuestsLoading', false)
  },
  async CreateRHPeriodoQuest({ commit, dispatch }, data) {
    commit('SetRHPeriodoQuestsLoading', true)
    var created = false
    try {
      await api.post('periodo-questionarios/', data)
      created = true
      dispatch('GetRHPeriodoQuests')
      commit("setAlerts", [{
        tag:'success',
        title:'Cadastro de Período/Questionário',
        message:`Período/Questionário criado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodoQuestsLoading', false)
    return created
  },
  async DeleteRHPeriodoQuest({ commit, dispatch }, data) {
    commit('SetRHPeriodoQuestsLoading', true)
    var deleted = false
    try {
      await api.delete(`periodo-questionarios/${data.id}/`)
      deleted = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Exclusão de Período/Questionário',
        message:`Período/Questionário removido com sucesso!`
        }])
      dispatch('GetRHPeriodoQuests')
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHPeriodoQuestsLoading', false)
    return deleted
  },
  // Colaboradores
  async GetRHColaboradores({ commit }, params) {
    commit('SetRHColaboradoresLoading', true)
    try {
      const response = await api.get(`colaboradores/`, { ...params, page_size: 1000 })
      commit('SetRHColaboradores', response.data.results)
    } catch (error) {
      commit('SetRHColaboradores', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHColaboradoresLoading', false)
  },
  async GetRHAvaliados({ commit }, params) {
    commit
    return await api.get(`respostas/avaliados/`, { ...params, page_size: 1000 })
  },
  async GetRHNaoAvaliados({ commit }, params) {
    commit
    // Colaboradores não avaliados, endpoint de Colaboradores para obter os colaboradores que não estao na lista de avaliados do periodoquestid
    return await api.get(`colaboradores/nao_avaliados/`, { ...params, page_size: 1000 })
  },

  async GetRHColaboradorResults({ commit }, data) {
    try {
      const response = await api.get(`colaboradores/${data.id}/results/`)
      return response.data
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
      return data
    }
  },
  async RHAvaliarColaborador({ commit }, data) {
    commit('SetRHAvaliarLoading', true)
    var avaliado = false
    try {
      await api.post('respostas/', data)
      avaliado = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Avaliação de Colaborador',
        message:`Colaborador avaliado com sucesso!`
      }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHAvaliarLoading', false)
    return avaliado
  },
  async RHRemoverAvaliacaoColaborador({ commit }, id) {
    commit('SetRHAvaliarLoading', true)
    var deleted = false
    try {
      await api.delete('respostas/'+id)
      deleted = true;
      commit("setAlerts", [{
        tag:'success',
        title:'Exclusão de Avaliação',
        message:`Avaliação removida com sucesso!`
        }])
    } catch (error) {
      commit("setAlerts", [ error.toast_message ])
    }
    commit('SetRHAvaliarLoading', false)
    return deleted
  },
  async GetAvaliacoesTempoCasa({commit}, params) {
    commit('setRHLoading', 'avaliacoes-tempo-casa')
    try{
      let response = await api.get('avaliacao-novo-colaborador/', params)
      commit('SetAvaliacoesTempoCasa', response.data)
    }catch(error){
      // commit('SetAvaliacoesTempoCasa', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('dropRHLoading', 'avaliacoes-tempo-casa')
  },
  async UpdateColabadorDoRm({commit}, data) {
    commit('setRHLoading', `update-colaborador-rm-${data.id}`)
    try{
      await api.post(`avaliacao-novo-colaborador/${data.id}/atualiza_do_rm/`)
    }catch(error){
      commit("setAlerts", [ error.toast_message ])
    }
    commit('dropRHLoading', `update-colaborador-rm-${data.id}`)
  },
  async UpdateAvaliacoesTempoCasa({commit}, data) {
    commit('setRHLoading', `update-avaliacao-tempo-casa-${data.id}`)
    try{
      await api.patch(`avaliacao-novo-colaborador/${data.id}/`, data)
    }catch(error){
      commit("setAlerts", [ error.toast_message ])
    }
    commit('dropRHLoading', `update-avaliacao-tempo-casa-${data.id}`)
  },
  async EnviarNotificacaoAvaliacaoTempoCasa({commit}, data) {
    commit('setRHLoading', `reenvio-notificacao-tempo-casa-${data.id}`)
    try{
      await api.post(`avaliacao-novo-colaborador/${data.id}/reenviar_notificacao/`, data)
      commit("setAlerts", [{
        tag:'success',
        title:'Envio de notificação',
        message:`Notificação enviada com sucesso!`
        }])
    }catch(error){
      // commit('SetAvaliacoesTempoCasa', [])
      commit("setAlerts", [ error.toast_message ])
    }
    commit('dropRHLoading', 'reenvio-notificacao-tempo-casa')
  },
}
export default {
  state,
  getters,
  actions,
  mutations
};